const arrayOfLength = (length: number) => {
  if (typeof length !== 'number' || length < 1) return []

  return Array.from({ length }).map((_, i) => i)
}

export default arrayOfLength
